import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { WhatsInside } from './components/WhatsInside';
import { RecipeTeaser } from './components/RecipeTeaser';
import { Benefits } from './components/Benefits';
import { WhoIsThisFor } from './components/WhoIsThisFor';
import { Testimonials } from './components/Testimonials';
import { Pricing } from './components/Pricing';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { BotanicalDivider } from './components/BotanicalDivider';
export function App() {
  return <div className="min-h-screen bg-parchment font-source text-brown selection:bg-sage selection:text-white" data-id="element-0">
      <Navbar data-id="element-1" />

      <main className="w-full overflow-x-hidden" data-id="element-2">
        <Hero data-id="element-3" />
        <SocialProofBar data-id="element-4" />
        <ProblemSection data-id="element-5" />
        <SolutionSection data-id="element-6" />
        <BotanicalDivider data-id="element-7" />
        <WhatsInside data-id="element-8" />
        <RecipeTeaser data-id="element-9" />
        <Benefits data-id="element-10" />
        <WhoIsThisFor data-id="element-11" />
        <BotanicalDivider data-id="element-12" />
        <Testimonials data-id="element-13" />
        <Pricing data-id="element-14" />
        <FAQ data-id="element-15" />
        <FinalCTA data-id="element-16" />
      </main>

      <Footer data-id="element-17" />
    </div>;
}